module.exports = __webpack_public_path__ + "static/media/icon-calendar.a792c44d.svg";